/**
 * Homepage section stack — card overlay for first N sections only.
 * Later sections scroll in normal document flow.
 */
(function () {
  var LIMIT = 3;

  function unwrap(main) {
    var existing = main.querySelector(':scope > .drip-stack-root');
    if (!existing) return;
    while (existing.firstChild) {
      main.insertBefore(existing.firstChild, existing);
    }
    existing.remove();
  }

  function apply() {
    if (!document.body.classList.contains('template-index')) return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    unwrap(main);

    var sections = Array.prototype.slice.call(
      main.querySelectorAll(':scope > .shopify-section')
    );

    sections.forEach(function (section) {
      section.classList.remove('drip-stack-section', 'drip-stack-after');
      section.style.removeProperty('--drip-stack-z');
    });

    if (!sections.length) return;

    var stackCount = Math.min(LIMIT, sections.length);
    var root = document.createElement('div');
    root.className = 'drip-stack-root';
    root.setAttribute('data-drip-stack-count', String(stackCount));

    var bg = getComputedStyle(document.documentElement).getPropertyValue('--color-background');

    for (var i = 0; i < stackCount; i++) {
      var section = sections[i];
      section.classList.add('drip-stack-section');
      section.style.setProperty('--drip-stack-z', String(i + 1));
      if (bg && bg.trim()) {
        section.style.setProperty('--drip-stack-bg', bg.trim());
      }
      root.appendChild(section);
    }

    main.insertBefore(root, main.firstChild);

    for (var j = stackCount; j < sections.length; j++) {
      sections[j].classList.add('drip-stack-after');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('shopify:section:reorder', apply);
  document.addEventListener('shopify:section:unload', apply);
  document.addEventListener('rz:mode:change', apply);
  document.addEventListener('theme:change', apply);
})();
